<template>
  <div class="title-box">
    <el-row>
      <el-col :span="24">
        <h2 class="title">{{ title }}</h2>
        <p class="subtitle">{{ subtitle }}</p>
      </el-col>
      <el-col :span="6">
        <slot
            name="button"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'BaseTitleBox',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
